module.exports = __webpack_public_path__ + "static/santander-cd8eb350fba5de8c5b8066475c9abe93.svg";